import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import SvgIcon from '../../svg-icon/SvgIcon';
import accessibleIcon from '../../accessible-icon/accessible-icon';
import withBrand from '../../with-brand/with-brand';
import getIconClasses from '../../../lib/get-icon-classes/get-icon-classes';
import styles from './ExpandCollapseIcon.less';

var ExpandCollapseIcon = function ExpandCollapseIcon(_ref) {
  var open = _ref.open,
      brand = _ref.brand,
      keepProps = _objectWithoutProperties(_ref, ["open", "brand"]);

  var classNames = getIconClasses({
    styles: styles,
    classes: ['icon'],
    brand: brand
  });
  var symbol = open ? /*#__PURE__*/React.createElement("rect", {
    x: "3.591",
    y: "7.49",
    width: "8.818",
    height: "1.018"
  }) : /*#__PURE__*/React.createElement("polygon", {
    points: "12.406,7.491 8.51,7.491 8.51,3.385 7.49,3.385 7.49,7.491 3.593,7.491 3.593,8.51 7.49,8.51 7.49,12.615 8.51,12.615 8.51,8.51 12.406,8.51"
  });
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, keepProps, {
    className: classNames
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.66,2.342C12.148,0.832,10.139,0,8,0C5.862,0,3.853,0.832,2.341,2.342c-3.121,3.12-3.121,8.195,0,11.314   C3.853,15.167,5.862,16,8,16c2.139,0,4.148-0.833,5.66-2.344C16.78,10.538,16.78,5.463,13.66,2.342z M12.938,12.937   C11.619,14.256,9.867,14.981,8,14.981c-1.866,0-3.62-0.726-4.939-2.045c-2.723-2.724-2.723-7.152,0-9.874   C4.38,1.745,6.134,1.018,8,1.018c1.867,0,3.619,0.727,4.938,2.045C15.663,5.785,15.663,10.215,12.938,12.937z"
  }), symbol);
};

ExpandCollapseIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  color: PropTypes.string,
  open: PropTypes.bool
};
ExpandCollapseIcon.defaultProps = {
  width: '16px',
  height: '16px',
  viewBox: '0 0 16 16',
  color: '#00698C'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon, withBrand)(ExpandCollapseIcon));